import { createSelector } from "reselect";

const _byId = (state) => state.paymentSources.byId;
const _allIds = (state) => state.paymentSources.allIds;

const allPaymentSources = createSelector(_byId, _allIds, (byId, allIds) =>
  allIds.map((id) => byId[id]),
);

const selectors = {
  allPaymentSources,
};

export default selectors;
